export default {
  data () {
    return {
      teamFields: [
        {
          label: 'Team / Project / Gift',
          key: 'team_name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th call-tabel'
        },
        {
          label: 'Gifts',
          key: 'totalBonuses',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th call-tabel--right call-tabel',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '80px' }
        }
      ],
      projectFields: [
        {
          label: '',
          key: 'project_name',
          sortable: false,
          tdClass: 'call-td call-td--bold gifts-report-project-name',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'totalBonuses',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '80px' }
        }
      ],
      bonusFields: [
        {
          label: '',
          key: 'bonus_name',
          sortable: false,
          tdClass: 'call-td gifts-report-bonus-name',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'bonus_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '80px' }
        }
      ]
    };
  }
};
